import GenerationFinishPage from './GenerationFinishPage'

export default GenerationFinishPage
